import { reactive } from 'vue'

// One banner at a time that slides down from the top of the screen, rendered once by
// AppBanner.vue. For news the user may act on (an app update, changed access); short
// confirmations stay with the toasts at the bottom.

export const bannerState = reactive({ current: null })

let timer = null

export function hideBanner() {
  clearTimeout(timer)
  const current = bannerState.current
  bannerState.current = null
  return current
}

// duration 0 keeps the banner until the user taps a button.
export function showBanner({ title, message = '', icon = 'mdi-bell-outline', action = null, dismissLabel = '', onDismiss = null, duration = 6000 }) {
  hideBanner()
  bannerState.current = { title, message, icon, action, dismissLabel, onDismiss }
  if (duration > 0) timer = setTimeout(hideBanner, duration)
}

export function dismissBanner() {
  hideBanner()?.onDismiss?.()
}

export function runBannerAction() {
  hideBanner()?.action?.onClick?.()
}
